import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    ButtonFooter,
    Container,
    ExpandButton,
    Modal,
    Text
} from 'mol-ui';

const AlertModal = ({
    active,
    message,
    onToggle
}) => {

    const { t } = useTranslation();

    return (
        <Modal
            active={ active }
            onToggle={ onToggle }
        >
            <Container>
                <Text fontSize="16px">{ message }</Text>
                <ButtonFooter margin="20px 0px 0px 0px">
                    <ExpandButton
                        caption={ t('Aceptar') }
                        size={ 100 }
                        onClick={ () => onToggle() }
                    />
                </ButtonFooter>
            </Container>
        </Modal>
    );
};

AlertModal.propTypes = {
    active: PropTypes.bool,
    message: PropTypes.string,
    onToggle: PropTypes.func
};

export default AlertModal;
